import { render, staticRenderFns } from "./pie-panjar.vue?vue&type=template&id=fcda7cbe&scoped=true&"
import script from "./pie-panjar.vue?vue&type=script&lang=js&"
export * from "./pie-panjar.vue?vue&type=script&lang=js&"
import style0 from "./pie-panjar.vue?vue&type=style&index=0&id=fcda7cbe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcda7cbe",
  null
  
)

export default component.exports